export default {
  RevenueEstimate: 'RevenueEstimate',
  RevenueOther: 'RevenueOther',
  RevenueEstimateOtherByLaw: 'RevenueEstimateOtherByLaw',
  ExpenseInvest: 'ExpenseInvest',
  ExpenseRegular: 'ExpenseRegular',
  ExpenseProgram: 'ExpenseProgram',
  ExpenseEstimateOtherByLaw: 'ExpenseEstimateOtherByLaw',
  EstimateBudget: 'EstimateBudget',
  RevenueExpenseFees: 'RevenueExpenseFees',
  EstimateExpenseBusiness: 'EstimateExpenseBusiness', // Chi từ nguồn HĐSNDV
  EstimateRevenueBusiness: 'EstimateRevenueBusiness', // Thu từ nguồn HĐSNDV
  EstimateRevenueFees: 'EstimateRevenueFees', // Thu phí, lệ phí
  EstimateExpenseFees: 'EstimateExpenseFees', // Chi phí, lệ phí
  EstimateExpenseOther: 'EstimateExpenseOther', // Chi khác
  EstimateExpenseBudget: 'EstimateExpenseBudget', // Chi nguồn
  ExpenseRegularArrgrate: 'ExpenseRegularArrgrate', // Lập chi thường xuyên phần Lập và cân đối
  EstimateExpenseRegular: 'EstimateExpenseRegular', // Chi thường xuyên
  EstimateExpenseProject: 'EstimateExpenseProject', // Chi ctmt
  RevenueExpenseFeesSectorWide: 'RevenueExpenseFeesSectorWide',
  RevenueOther: 'RevenueOther', // Thu khác
  RevenueBudget: 'RevenueBudget' // Thu NSNN
};
